export enum FileUploadType {
    PRODUCT = 'PRODUCT',
    DOC = 'DOC',
    CATEGORY = 'CATEGORY',
}
